export enum ChatbotConversationStatusEnum {
    ENABLED = 'Habilitado',
    DISABLED = 'Deshabilitado'
}

export enum ChatbotMessageStatus {
    SENT = 'Enviado',
    PROCESSING = 'Procesando respuesta',
    ANSWER_RECEIVED = 'Respuesta recibida'
}


export enum ChatConversationStatus {
    ENABLED = 0,
    DISABLED = 1
}

export enum MessageType {
    USER = 0,
    BOT = 1
}

export enum ChatMessageStatus  {
    SENT = 0,
    PROCESSING = 1,
    ANSWER_RECEIVED = 2
}

export const chatbotProperties = {
    conversation: {
        [ChatConversationStatus.ENABLED]: ChatbotConversationStatusEnum.ENABLED,
        [ChatConversationStatus.DISABLED]: ChatbotConversationStatusEnum.DISABLED
    },
    message: {
        [ChatMessageStatus.SENT]: ChatbotMessageStatus.SENT,
        [ChatMessageStatus.PROCESSING]: ChatbotMessageStatus.PROCESSING,
        [ChatMessageStatus.ANSWER_RECEIVED]: ChatbotMessageStatus.ANSWER_RECEIVED
    }
}

export type ChatbotProperties = typeof chatbotProperties